import { NgxLoggerLevel } from 'ngx-logger';
import pkg from '../../package.json';
const { name, version } = pkg;
import { activeAreas, EnvironmentSettings } from './environment-settings.model';
import { ApiPaths } from './api-paths';

const apiRoot = 'https://uat.unity.uk.com/API/v2/';
const apiPaths: ApiPaths = {
  root: apiRoot,
  authorisation: `${apiRoot}authorisation/`,
  activeSecurity: `${apiRoot}auth-n`,
  users: `${apiRoot}users`,
  MarketMessenger: `${apiRoot}MarketMessaging/`,
};

export const environment: EnvironmentSettings = {
  environment: 'uat',
  appName: name,
  appVersion: version,
  production: false,
  loggingConfig: {
    threshold: NgxLoggerLevel.TRACE,
    logToExternalService: true
  },
  suppressBeforeUnloadEvent: false,
  apiRoot,
  apiPaths,
  appId: "2E85FA18-7065-46BF-8DC0-0E445F80D67F",
  pwaDisabled: false, 
  cryptoSalt: "rt3dSx97fgHO428q",
  graphUri: 'https://graph.microsoft.com/v1.0/me',
  msalSettings: {
    clientId: "cc7be351-895d-4352-897a-7be765f326cb",
    redirect: "https://uat.unity.uk.com/auth/(top:sso-auth)",
    authority: "https://login.microsoftonline.com/common/",
    verboseLogging: true
  },
  cacheDurationInMinutes: 20,
  renderMsLogin: true,
  activeAreas: [
    activeAreas.MarketMessenger,
    activeAreas.MessageVault,
    activeAreas.Reports,
    activeAreas.Settings,
  ],
  googleMapsApiKey: '',
}; 